import axios from "axios";
import Cookies from "js-cookie";
import { ID } from "models";

export const patchCreativeGroupV2 = ({ id, group }: { id: ID; group: any }) => {
  return axios
    .put(`/api/v2/creative_group/${id}/`, group, {
      headers: {
        "X-CSRFToken": Cookies.get("csrftoken"),
        "Content-Type": "application/json;charset=utf-8"
      }
    })
    .then((res) => {
      return res;
    });
};
